import { useProfileQuery } from "@/queries/user/profile";
import { useImpersonationStore } from "@/stores/user-impersonation";
import { Button } from "@/components/ui/button";

const ImpersonationFooter = () => {
  const { profile } = useProfileQuery();
  const { impersonatedUserId, setImpersonatedUserId } = useImpersonationStore();

  if (!impersonatedUserId) {
    return;
  }

  return (
    <nav className="sticky bottom-0 z-10 justify-between items-center bg-[#003C32]">
      <div className="w-full py-3 px-4 flex flex-col gap-2 justify-between items-center">
        <p className="text-normal font-medium text-white">
          Your are currently impersonating {profile?.name ?? "another user"}
        </p>
        <Button variant="secondary" onClick={() => setImpersonatedUserId(null)}>
          Stop Impersonating
        </Button>
      </div>
    </nav>
  );
};

export default ImpersonationFooter;
